module.exports = __webpack_public_path__ + "img/idc_level.3f2ce54c.jpg";